import React from 'react';

const FundOnePage = React.lazy(() => import('@apps/Finances/pages/FundOnePage'));

const FundsPage = React.lazy(() => import('@apps/Finances/pages/FundsPage'));

import { IPohodnikRouterItem } from '.';

const financesRoutes: Array<IPohodnikRouterItem> = [
  {
    path: '/finances/funds/:id',
    component: ({
      match: {
        params: { id },
      },
    }) => <FundOnePage id={id} />,
    title: 'Фонд',
  },
  {
    path: '/finances/funds',
    component: () => <FundsPage />,
    protected: true,
    title: 'Фонды',
  },
];

export default financesRoutes;
